export const SEARCH_BAR_EXTERNAL_RADIUS = '50px';
export const SEARCH_BAR_TYPE_SELECT_WIDTH = '190px';
export const SEARCH_BAR_WHOLE_WIDTH = '575px';
export const SEARCH_BAR_WHOLE_WIDTH_HIDDEN = '366px';
export const SEARCH_BAR_WHOLE_HEIGHT = '36px';

export const ORDERS_SEARCH_BAR_CLEAR_INDICATOR_ID =
  'orders-search-bar-clear-indicator';

export const SEARCH_OPTION_SEPARATOR = ': ';
